import React, { useState, useEffect, useRef } from 'react';
import { Image, Group, Rect, Text } from 'react-konva';
import useImage from 'use-image';
import { getProxiedImageUrl } from '../utils/imageProxy';
import type { AvatarItem } from '../types/types';

interface DraggableImageProps {
  item: AvatarItem;
  onDragEnd: (id: string, newPos: { x: number; y: number }) => void;
}

const DraggableImage: React.FC<DraggableImageProps> = ({ item, onDragEnd }) => {
  const [currentUrl, setCurrentUrl] = useState<string>('');
  const groupRef = useRef<any>(null);
  
  
  useEffect(() => {
    
    const finalUrl = item.src; 
    setCurrentUrl(finalUrl);
      }, [item.src, item.id]);

  const [image, status] = useImage(currentUrl, 'anonymous');

  const handleDragEnd = (e: { target: { x: () => number; y: () => number; getLayer?: () => any } }) => {
    const node = e.target;
    
    onDragEnd(item.id, {
      x: node.x(),
      y: node.y(),
    });
    
    
    if (node.getLayer) {
      const layer = node.getLayer();
      if (layer) {
        
        setTimeout(() => {
          const children = layer.getChildren();
          children.sort((a: any, b: any) => {
            const zIndexA = a.getAttr('zIndex') || 0;
            const zIndexB = b.getAttr('zIndex') || 0;
            return zIndexA - zIndexB;
          });
          layer.batchDraw();
        }, 0);
      }
    }
  };

  const handleDragStart = () => {
    
    
      };

  
    
  useEffect(() => {
    if (status === 'failed' && currentUrl.includes('/api/image-proxy')) {
            setCurrentUrl(item.src);
    }
  }, [status, currentUrl, item.src, item.id]);

  
  useEffect(() => {
    if (groupRef.current) {
      groupRef.current.setAttr('zIndex', item.zIndex);
    }
  }, [item.zIndex]);

  if (status === 'loading') {
    if (item.category === 'base') {
      return (
        <Group x={0} y={0} zIndex={item.zIndex} listening={false}>
          <Rect x={40} y={70} width={320} height={420} fill="#f3f4f6" cornerRadius={12} />
          <Text
            x={60}
            y={260}
            width={280}
            text="Carregando avatar..."
            align="center"
            fontSize={18}
            fill="#6b7280"
          />
        </Group>
      );
    }
    return null;
  }

  if (status === 'failed' || !image) {
    if (item.category === 'base') {
      return (
        <Group x={0} y={0} zIndex={item.zIndex} listening={false}>
          <Rect x={40} y={70} width={320} height={420} fill="#fef3c7" cornerRadius={12} />
          <Text
            x={60}
            y={240}
            width={280}
            text="Não foi possível carregar a base do avatar"
            align="center"
            fontSize={16}
            fill="#92400e"
          />
          <Text
            x={60}
            y={275}
            width={280}
            text="Tente novamente em instantes"
            align="center"
            fontSize={14}
            fill="#92400e"
          />
        </Group>
      );
    }
    return null;
  }

  
  const isDraggable = item.category !== 'base';

  
  
  let width, height, finalX, finalY;
  
  if (item.category === 'base') {
    
    const canvasWidth = 400;
    const canvasHeight = 500;
    const imageWidth = image.width;
    const imageHeight = image.height;
    
    
    const scaleX = canvasWidth / imageWidth;
    const scaleY = canvasHeight / imageHeight;
    const scale = Math.min(scaleX, scaleY, 1); 
    
    
    width = imageWidth * scale;
    height = imageHeight * scale;
    
    
    finalX = (canvasWidth - width) / 2;
    finalY = (canvasHeight - height) / 2;
    
      } else {
    
    width = image.width * (item.scale || 1);
    height = image.height * (item.scale || 1);
    finalX = item.x;
    finalY = item.y;
  }

  finalY = finalY + 50;

    return (
    <Group
      ref={groupRef}
      x={0}
      y={0}
      zIndex={item.zIndex}
      draggable={isDraggable}
      onDragStart={isDraggable ? handleDragStart : undefined}
      onDragEnd={isDraggable ? handleDragEnd : undefined}
      
      listening={true}
    >
      <Image
        image={image}
        x={finalX}
        y={finalY}
        width={width}
        height={height}
        rotation={item.rotation || 0}
        
        draggable={false}
        listening={false}
      />
    </Group>
  );
};

export default DraggableImage;
